export enum ApjTitleEnum {
  APJ = 'Apoteker Penanggung Jawab',
  PJT = 'Penanggung Jawab Teknis',
}

export enum ApjTitleAbbreviation {
  APJ = 'APJ',
  PJT = 'PJT',
}

export enum ApjLicenseLabel {
  STRA = 'No. STRA',
  IJAZAH = 'No. Ijazah',
}
